import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Home, Flame, ShieldAlert, Store, Factory, Lock, ShieldCheck, Heart, Award } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const PropertyInsurance = () => {
    const { t } = useLanguage();

    const propPlans = [
        { key: 'ft_prop_home', icon: Home, desc: 'Protect your dream sanctuary from fire, theft, and natural hazards.' },
        { key: 'ft_prop_fire', icon: Flame, desc: 'Highest coverage at lowest premium for fire-related damages.' },
        { key: 'ft_prop_burg', icon: Lock, desc: 'Total peace of mind with 24/7 financial protection against burglary.' },
        { key: 'ft_prop_shop', icon: Store, desc: 'Customized insurance for shopkeepers covering stock and equipment.' },
        { key: 'ft_prop_indus', icon: Factory, desc: 'Industrial-grade property insurance for manufacturing units.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_property')}
                subtitle="Your home and property are more than just assets — they're your future. Secure them with the industry's strongest protection."
                bgGradient={true}
                image="/assets/property-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Property Protection Suite</h2>
                    <p className="section-subtitle">Comprehensive solutions for your residential, commercial, and industrial properties.</p>
                </div>
                
                <div className="grid grid-3">
                    {propPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Why Insure Your Property?</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <ShieldAlert className="feature-icon" />
                            <h4>Natural Calamities</h4>
                            <p>Full protection against earthquakes, floods, storms, and other catastrophic weather events.</p>
                        </div>
                        <div className="feature-item">
                            <Lock className="feature-icon" />
                            <h4>Theft & Vandalism</h4>
                            <p>Coverage for stolen contents, damaged building structure, and expensive internal fittings.</p>
                        </div>
                        <div className="feature-item">
                            <Heart className="feature-icon" />
                            <h4>Alternative Accommodation</h4>
                            <p>Get rent for temporary housing if your insured property becomes uninhabitable due to damage.</p>
                        </div>
                        <div className="feature-item">
                            <Award className="feature-icon" />
                            <h4>Public Liability</h4>
                            <p>Protect yourself against legal liabilities if a third-party is injured within your property.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Get Your Property Valued</h3>
                    <p>Speak to our assessment experts to determine the right sum insured for your property today.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Talk to Advisor</button>
                </div>
            </div>
        </div>
    );
};

export default PropertyInsurance;
